/**
 * 날짜 포맷 유틸.
 * 서버는 ISO-8601(UTC) 문자열을 내려주고, 화면은 KST 기준으로 표기한다.
 */
const KST_OFFSET_MINUTES = 9 * 60

function toKstDate(iso: string): Date | null {
  if (!iso) return null

  const parsed = new Date(iso)
  if (Number.isNaN(parsed.getTime())) return null

  return new Date(parsed.getTime() + KST_OFFSET_MINUTES * 60 * 1000)
}

function pad(value: number): string {
  return value.toString().padStart(2, "0")
}

/** yyyy.MM.dd */
function toYearDay(iso: string, separator = "."): string {
  const date = toKstDate(iso)
  if (!date) return ""

  return [
    date.getUTCFullYear(),
    pad(date.getUTCMonth() + 1),
    pad(date.getUTCDate()),
  ].join(separator)
}

/** yyyy.MM.dd HH:mm */
function toYearDayTime(iso: string): string {
  const date = toKstDate(iso)
  if (!date) return ""

  return `${toYearDay(iso)} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`
}

const WEEKDAY_NAMES = ["일", "월", "화", "수", "목", "금", "토"]

/** yyyy년 M월 d일 E요일 */
function toKoreanFullDate(iso: string): string {
  const date = toKstDate(iso)
  if (!date) return ""

  const weekday = WEEKDAY_NAMES[date.getUTCDay()]

  return `${date.getUTCFullYear()}년 ${date.getUTCMonth() + 1}월 ${date.getUTCDate()}일 ${weekday}요일`
}

/**
 * ISO(UTC) → `<input type="datetime-local">` 값 (KST 기준 yyyy-MM-ddTHH:mm)
 *
 * 관리자 폼이 다루는 값이라 표시용 포맷과 따로 둔다 — 화면 표기와 입력 값을 섞으면
 * 저장할 때 포맷을 되돌리지 못한다.
 */
function toInputDateTime(iso: string): string {
  const date = toKstDate(iso)
  if (!date) return ""

  const yearDay = [
    date.getUTCFullYear(),
    pad(date.getUTCMonth() + 1),
    pad(date.getUTCDate()),
  ].join("-")

  return `${yearDay}T${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`
}

/**
 * 오늘 날짜(KST)의 `<input type="date">` 값 — yyyy-MM-dd
 *
 * 생년월일처럼 미래를 고를 수 없는 입력의 `max` 로 쓴다.
 */
function toTodayInputDate(): string {
  const now = new Date()
  const kstNow = new Date(now.getTime() + KST_OFFSET_MINUTES * 60 * 1000)

  return [
    kstNow.getUTCFullYear(),
    pad(kstNow.getUTCMonth() + 1),
    pad(kstNow.getUTCDate()),
  ].join("-")
}

/** `<input type="datetime-local">` 값(KST) → ISO(UTC) 문자열 */
function toIsoFromInput(localDateTime: string): string {
  if (!localDateTime) return ""

  const parsed = new Date(`${localDateTime}:00+09:00`)
  if (Number.isNaN(parsed.getTime())) return ""

  return parsed.toISOString().replace(/\.\d{3}Z$/, "Z")
}

export {
  toInputDateTime,
  toIsoFromInput,
  toKoreanFullDate,
  toTodayInputDate,
  toYearDay,
  toYearDayTime,
}
